import React from "react";
import styles from "./CustomTitle.module.css";
import { SiRundeck } from "react-icons/si";
const CustomTitle = (props) => {
  return (
    <div>
      <h2 className={styles.titlegradient}>
        {props.children} <SiRundeck color="#ffcd38" size={25} />
      </h2>
    </div>
  );
};

export default CustomTitle;
